const Header = () => {
    return <h1>Games Reviews</h1>
}

export default Header